import { Message } from 'lib-shared-legacy-types';
import { useMemo } from 'react';

import TextMessage, { TextMessageProps } from './TextMessage';
import { getAttachment } from './utils/attachment';
import { useTranslatePlainTextConversationMessage } from './utils/useTranslatePlainTextConversationMessage';

type MessageSmsProps = {
  message: Message;
} & TextMessageProps;

export const MessageSms = (props: MessageSmsProps): JSX.Element => {
  const attachment = useMemo(
    () => getAttachment(props.message, { scaleImage: true }),
    [props.message],
  );

  const { button, translation } = useTranslatePlainTextConversationMessage({
    text: props.message.text ?? undefined,
    isDisabled: !!attachment,
    originalLanguageCode: props.message.language ?? null,
  });

  return (
    <TextMessage
      {...props}
      content={attachment}
      gutterButtons={button}
      translation={translation}
    />
  );
};
